/* Copyright 2021, Milkdown by Mirone. */
export var ToolTipPos;
(function (ToolTipPos) {
    ToolTipPos["Left"] = "Left";
    ToolTipPos["Top"] = "Top";
    ToolTipPos["Point"] = "Point";
})(ToolTipPos || (ToolTipPos = {}));
//# sourceMappingURL=constant.js.map